export const APP = {
  API: process.env.REACT_APP_BATTALEBARDS_API_URL,
  SOCKET: process.env.REACT_APP_BATTALEBARDS_SOCKET_URL,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  FACEBOOK_CLIENT_ID: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
  COOKIE_DAYS: 90,
};
